import { tableConfig } from 'src/settings';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import notifications from 'src/redux/notifications/actions';
import { logger } from 'src/helpers/logger';
import { IRequestParams, IResponse } from '@dash/apiInstance';
import ApiInstance from 'src/helpers/apiInstance';
import { sendRequest } from 'src/helpers/saga';
import { LoadListDataAction } from './actions.d';
import actionTypes from './actionTypes';
import actions from './actions';
import { IAgencyWorkerRecord } from '../types';

const api = new ApiInstance('agencies/worker_identities');

function normalizeRecords(records: IAgencyWorkerRecord[] = []) {
  return records.map((row, index) => {
    const group_id = row.id ?? `row-${index}`;

    if (Array.isArray(row.workers) && row.workers.length === 1) {
      return { ...row, group_id };
    }

    if (Array.isArray(row.workers) && row.workers.length > 1) {
      return {
        ...row,
        group_id,
        children: row.workers.map(w => ({
          group_id,
          ...w,
        })),
      };
    }

    return { ...row, group_id };
  });
}

function* loadAgencyWorkers({ payload }: LoadListDataAction<{}, {}>): Generator<any, void, any> {
  try {
    const {
      page = 1,
      pageSize = tableConfig.pageSize,
      column,
      order,
      filter = '',
      agency_ids,
      ...filterParams
    } = payload;

    const result: IResponse<any> = yield call<any, IRequestParams<{}, {}>, string>(
      sendRequest,
      api.get,
      { search: { page, pageSize, column, order, filter, agency_ids, ...filterParams } },
      notifications.REQUEST_ERROR,
    );

    if (result.status === 200 && result.data) {
      const { records, filters, filteredCount, totalCount } = result.data;
      const normalized = normalizeRecords(records);

      yield put(
        actions.loadListDataSuccess({
          records: normalized,
          filters,
          filteredCount,
          totalCount,
        }),
      );
    } else {
      yield put(actions.loadListDataError());
    }
  } catch (e) {
    yield put(actions.loadListDataError());
    logger.error(e);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actionTypes.LOAD_LIST_DATA, loadAgencyWorkers)]);
}
